import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Categories } from './components/Categories';
import { Abundance } from './components/Abundance';
import { Transformation } from './components/Transformation';
import { Demo } from './components/Demo';
import { Value } from './components/Value';
import { Bonuses } from './components/Bonuses';
import { OfferSummary } from './components/OfferSummary';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { BuyBar } from './components/BuyBar';
import { UpsellProvider } from './components/UpsellContext';
import { UpsellModal } from './components/UpsellModal';
export function App() {
  return <UpsellProvider data-id="element-0">
      <main className="min-h-screen bg-cream font-sans text-dark overflow-x-hidden selection:bg-rose-light selection:text-dark pb-24" data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Categories data-id="element-4" />
        <Abundance data-id="element-5" />
        <Transformation data-id="element-6" />
        <Demo data-id="element-7" />
        <Value data-id="element-8" />
        <Bonuses data-id="element-9" />
        <OfferSummary data-id="element-10" />
        <Guarantee data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <BuyBar data-id="element-15" />
        <UpsellModal data-id="element-16" />
      </main>
    </UpsellProvider>;
}